module.exports = __webpack_public_path__ + "media/images/favicon/favicon-32x32-4be768989a74e1bca54273f81a656b8c.png";